import React from 'react';
import type { Message, ConnectionStatus } from '../types';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { LanguageSelector, LanguageCode } from './LanguageSelector';
import '../styles/widget.css';

interface ChatWindowProps {
  title?: string;
  messages: Message[];
  isTyping: boolean;
  connectionStatus: ConnectionStatus;
  onSend: (message: string) => void;
  onClose: () => void;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  placeholder?: string;
  disabled?: boolean;
  selectedLanguage?: LanguageCode;
  onLanguageChange?: (language: LanguageCode) => void;
}

export const ChatWindow: React.FC<ChatWindowProps> = ({
  title = 'Chat Support',
  messages,
  isTyping,
  connectionStatus,
  onSend,
  onClose,
  position = 'bottom-right',
  placeholder,
  disabled = false,
  selectedLanguage = 'en',
  onLanguageChange,
}) => {
  const getStatusText = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Online';
      case 'connecting':
        return 'Connecting...';
      case 'disconnected':
        return 'Offline';
      case 'error':
        return 'Connection error';
      default:
        return '';
    }
  };

  return (
    <div className={`securedevkit-chat-window ${position}`}>
      <div className="securedevkit-chat-header">
        <div>
          <h3 className="securedevkit-chat-header-title">{title}</h3>
          <div className="securedevkit-chat-status">
            <span
              className={`securedevkit-chat-connection-status ${connectionStatus}`}
            ></span>
            {getStatusText()}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {onLanguageChange && (
            <LanguageSelector
              selectedLanguage={selectedLanguage}
              onLanguageChange={onLanguageChange}
            />
          )}
          <button
            className="securedevkit-chat-header-close"
            onClick={onClose}
            aria-label="Close chat"
          >
            ×
          </button>
        </div>
      </div>
      <MessageList messages={messages} isTyping={isTyping} />
      <MessageInput
        onSend={onSend}
        disabled={disabled || connectionStatus !== 'connected'}
        placeholder={placeholder}
      />
    </div>
  );
};

